<template>
  <table :class="{ 'is-loading': isLoading }">
    <tr v-for="(data, idx) in dataArray" :key="`tktable-navItem__${idx}`">
      <!-- eslint-disable vue/no-v-html -->
      <th v-if="isHtml" v-html="data.title"></th>
      <!--eslint-enable-->
      <th v-else>{{ data.title }}</th>
      <td>
        <template v-if="isLoading">
          <tk-skeleton-loader style="width: 100%;" />
        </template>
        <template v-else>
          <!-- eslint-disable vue/no-v-html -->
          <span v-if="isHtml" v-html="data.text"></span>
          <!--eslint-enable-->
          <span v-else>{{ data.text }}</span>
          <tk-link
            v-if="data.link"
            :href="data.link.href"
            :class="data.link.class"
            @click="parentEvent(data)"
            >{{ data.link.text }}</tk-link
          >
        </template>
      </td>
    </tr>
  </table>
</template>

<script>
import TkLink from '../TkLink/TkLink'
import TkSkeletonLoader from '../TkSkeletonLoader/TkSkeletonLoader'
export default {
  name: 'TkTable',
  components: { TkLink, TkSkeletonLoader },
  props: {
    dataArray: {
      type: Array,
      required: true,
    },
    isHtml: {
      type: Boolean,
      required: false,
      default: false,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {},
  methods: {
    parentEvent(data) {
      this.$emit(data.link.event)
    },
  },
}
</script>

<style lang="scss">
@import '~@ota-frontend/ui/src/scss/components/TkTable.scss';
</style>
